import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
}

export const PricingWizardIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`pricing-wizard-icon ${className || ''}`} height={689} width={689}>
			<circle cx='344.5' cy='344.5' r='344.5' fill='#DBF2C3' />
			<g opacity='.618'>
				{/* Calculator body */}
				<rect x='180' y='150' width='329' height='420' rx='20' fill='#89C947' />
				<rect x='200' y='180' width='289' height='80' rx='10' fill='#fff' />

				{/* Calculator buttons */}
				<circle cx='240' cy='310' r='25' fill='#3F3D56' />
				<circle cx='320' cy='310' r='25' fill='#3F3D56' />
				<circle cx='400' cy='310' r='25' fill='#3F3D56' />
				<circle cx='240' cy='380' r='25' fill='#3F3D56' />
				<circle cx='320' cy='380' r='25' fill='#3F3D56' />
				<circle cx='400' cy='380' r='25' fill='#3F3D56' />
				<circle cx='240' cy='450' r='25' fill='#3F3D56' />
				<circle cx='320' cy='450' r='25' fill='#3F3D56' />
				<circle cx='400' cy='450' r='25' fill='#3F3D56' />
				<circle cx='240' cy='520' r='25' fill='#3F3D56' />
				<rect x='295' y='495' width='130' height='50' rx='10' fill='#00528C' />

				{/* Dollar sign */}
				<text x='350' y='235' fontSize='60' fontWeight='bold' fill='#89C947' textAnchor='middle'>
					$
				</text>
			</g>
		</SvgIcon>
	);
};
